import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/show_process/${packing_house_process_id}`
    );
  },

  fetchProcessLineStep(packing_house_id, process_line_step_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/process_line_step/${process_line_step_id}`
    );
  },

  fetchProcessLines(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/${packing_house_process_id}/fetch_process_lines`
    );
  },

  fetchProcessLineExecStep(packing_house_id, process_line_exec_step_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_process_line_exec_step/${process_line_exec_step_id}`
    );
  },

  fetchCropTypes(packing_house_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_crop_types`
    );
  },

  fetchProducers(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_producers/${packing_house_process_id}`
    );
  },

  fetchProducersFormalized(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_producers_formalized/${packing_house_process_id}`
    );
  },

  fetchProducerByCode(packing_house_id, packing_house_process_id, output_code) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_producer_by_code/${packing_house_process_id}/${output_code}`
    );
  },

  fetchCropFields(packing_house_id, packing_house_process_id, producer_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_crop_fields/${packing_house_process_id}/${producer_id}`
    );
  },

  fetchAgroExporterProcesses(packing_house_id, packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_agro_exporter_processes/${packing_house_process_id}`
    );
  },

  fetchProcessLineExecOutputs(
    packing_house_id,
    process_line_step_id,
    process_line_product_id,
    process_line_exec_input_id
  ) {
    return RequesterV1.get(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/fetch_process_line_exec_outputs/${process_line_step_id}/${process_line_product_id}/${
        process_line_exec_input_id ?? ""
      }`
    );
  },

  create(packing_house_id, process_line_exec_step) {
    return RequesterV1.post(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/create`,
      { process_line_exec_step }
    );
  },

  update(packing_house_id, process_line_exec_step_id, process_line_exec_step) {
    return RequesterV1.patch(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/${process_line_exec_step_id}/update`,
      { process_line_exec_step }
    );
  },

  destroy(packing_house_id, process_line_exec_step_id) {
    return RequesterV1.delete(
      `packing_house/process/exec_steps/${packing_house_id}/new_exec_step/${process_line_exec_step_id}/destroy`
    );
  },
};
